module.exports = __webpack_public_path__ + "rosacea_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_1_after.jpg
// module id = 977
// module chunks = 0